import { format } from 'date-fns';
import { ApiGridParams } from '@interfaces/central-monitoring';
import { getUTCDate } from '@utils-clean/date-time-helpers';

export const getExportFileName = (grid: ApiGridParams['grid'], studyNumber: string): string => {
    switch (grid) {
        case 'SmObservations':
            return `Subject Observations_${studyNumber}_${format(getUTCDate(), 'dd-MMM-yyyy')}`;
        case 'SmActions':
            return `Subject Actions_${studyNumber}_${format(getUTCDate(), 'dd-MMM-yyyy')}`;
        case 'SmReviewLog':
            return `Subject Review Logs_${studyNumber}_${format(getUTCDate(), 'dd-MMM-yyyy')}`;
        default:
            return `${grid}_${studyNumber}_${format(getUTCDate(), 'dd-MMM-yyyy')}`;
    }
};

export const getExportChildFileName = (grid: ApiGridParams['grid'], studyNumber: string, recordId?: string): string => {
    switch (grid) {
        case 'SmObservations':
            return `Subject Observation ID ${recordId}_${studyNumber}_${format(getUTCDate(), 'dd-MMM-yyyy')}`;
        case 'SmActions':
            return `Subject Actions for Subject Observation ID ${recordId}_${studyNumber}_${format(getUTCDate(), 'dd-MMM-yyyy')}`;
        case 'SmReviewLog':
            return `Subject Review Logs for Subject Obs ID ${recordId}_${studyNumber}_${format(getUTCDate(), 'dd-MMM-yyyy')}`;
        default:
            return `Subject Observation ID ${recordId}_${studyNumber}_${format(getUTCDate(), 'dd-MMM-yyyy')}`;
    }
};
